import { createAsyncThunk } from '@reduxjs/toolkit';
import ModelAPI from './services';

export const fetch = createAsyncThunk('model/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await ModelAPI.fetchAll(params);

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
